import {
  SavePripomienka as EditPripomienkaGenerated,
  SaveAdminPripomienka as EditAdminPripomienkaGenerated,
  EditPripomienkaApi,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import Uuid from '../model/Uuid';
import SavePripomienka from '../model/pripomienka/SavePripomienka';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import SaveAdminPripomienka from '../model/pripomienka/SaveAdminPripomienka';
import dateToString from '../function/dateToString';
import { povahaPripomienkyToGenerated } from '../model/pripomienka/PovahaPripomienky';
import { stavPripomienkyToGenerated } from '../model/pripomienka/StavPripomienky';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new EditPripomienkaApi(apiConfiguration(pripomienkyPrefixPath));

const map = (pripomienka: SavePripomienka): EditPripomienkaGenerated => ({
  clanok: pripomienka.clanok,
  paragraf: pripomienka.paragraf,
  odsek: pripomienka.odsek,
  celyMaterial: pripomienka.celyMaterial,
  ine: pripomienka.ine,
  textPripomienky: pripomienka.text,
  zasadna: pripomienka.zasadna,
});

const mapAdminPripomienka = (pripomienka: SaveAdminPripomienka): EditAdminPripomienkaGenerated => ({
  pripomienkujuciSubjekt: pripomienka.pripomienkujuciSubjekt ? pripomienka.pripomienkujuciSubjekt.uuid : null,
  pripomienkovatel: pripomienka.pripomienkovatel ? pripomienka.pripomienkovatel.uuid : null,
  datumVytvorenia: dateToString(pripomienka.datumVytvorenia),
  clanok: pripomienka.clanok,
  paragraf: pripomienka.paragraf,
  odsek: pripomienka.odsek,
  celyMaterial: pripomienka.celyMaterial,
  ine: pripomienka.ine,
  textPripomienky: pripomienka.text,
  zasadna: pripomienka.zasadna,
  odoslana: pripomienka.odoslana,
  povahaPripomienky: povahaPripomienkyToGenerated(pripomienka.povahaPripomienky),
  priradeny: pripomienka.priradeny ? pripomienka.priradeny.uuid : null,
  vyhodnotil: pripomienka.vyhodnotil ? pripomienka.vyhodnotil.uuid : null,
  stav: stavPripomienkyToGenerated(pripomienka.stavPripomienky),
  textVyhodnotenia: pripomienka.textVyhodnotenia,
});

export const editPripomienka = async (
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  pripomienka: SavePripomienka,
  options?: AxiosRequestConfig,
):
    Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editPripomienka(
    type,
    year,
    index,
    uuid,
    map(pripomienka),
    options,
  );
  return {
    responseCode: status,
  };
};

export const editPripomienkaAdmin = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  pripomienka: SaveAdminPripomienka,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editPripomienkaAdmin(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    uuid,
    mapAdminPripomienka(pripomienka),
    options,
  );
  return {
    responseCode: status,
  };
};
